function refreshCart(t) {
  $.getJSON('/cart.js').then(function(cart) {
    var htm = '';
    cart.items.forEach(function(item) {
      htm += '<div class="row-cart">';
      if (item && item.featured_image && item.featured_image.url) {
        htm += '<img class="cart-notification-product__image" src="'+item.featured_image.url+'" alt="" width="119" height="123" loading="lazy">';
      } else {
        htm += '<img class="cart-notification-product__image" src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" alt="" width="119" height="123" loading="lazy">';
      }
      htm += '<a href="javascript:void(0)" class="removeitem" data-variant-id="'+item.id+'">X Remove</a>';
      htm += '<div class="cart_item_content">';
      htm += '<a href="'+item.url+'">';
      htm += '<h3 class="cart-notification-product__name h4">'+item.product_title+'</h3>';
      htm += '</a>';
      htm += '<dl><div class="product-option bhc-'+item.options_with_values[0].value+'">';
      htm += '<dt>'+item.options_with_values[0].name+': </dt>';
      htm += '<dd>'+item.options_with_values[0].value+'</dd>';
      htm += '</div>';
      htm += '<div class="product-option">';
      htm += '<dt>Qty: </dt>';
      htm += '<dd>'+item.quantity+'</dd>';
      htm += '</div>';
      htm += '</dl>';
      htm += '</div>';
      htm += '</div>';
    });
    $('#cart-notification-product').html(htm);
    var a = cart.total_price/100;
    a = a.toFixed(2);
    $('.mini-cart-total-price span').text('$'+a);
    $('.cart-count-bubble span').html('('+cart.item_count+')');
    
    if (t == false) {
      $('a#cart-icon-bubble').trigger('click');
      $('.point-to-icon').addClass('animate active');
      $('body').addClass('drawer--open');
      $('.overlay_body').show();
    }
    
    if (cart.items.length == 0) {
      $('div#cart-notification .cart-notification__links').hide();
      $('.cartempty').show();
    } else {
      $('.cartempty').hide();
      $('div#cart-notification .cart-notification__links').show();
    }

    jQuery.get('/cart?view=cart_free_shipping', function(pro) {
      $('.productshippingbar').html(pro);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.log('getJSON request failed! ' + textStatus);
    }).done(function(){
      // $this.removeClass('recommendations');
    });
    
  })
  .fail(function(err){
    console.log(err);
  });
}

$(document).ready(function() {
  $('li.single_image').on('click', function() {
  	$('#product-grid').addClass('grid--1-col');
    $('#product-grid').removeClass('grid--2-col');
  });
  $('li.multicol_image').on('click', function() {
  	$('#product-grid').addClass('grid--2-col');
    $('#product-grid').removeClass('grid--1-col');
  });
  
  $('.featured-carousel').owlCarousel({
    center: true,
    loop:true,
    items: 2,
    nav: true,
    autoplay: true,
    margin: 30,
    dots: false,
    loop: true,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>","<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>"],
    responsive:{
        600:{
          center: false,
          nav: false,
          items:4
        }
    }
});
  
    $('.featured-carousel-main').owlCarousel({
    loop:true,
    items: 2,
    nav: true,
    autoplay: true,
    margin: 10,
    dots: false,
    loop: true,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>","<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>"],
    responsive:{
        600:{
          center: false,
          nav: false,
          items:4
        }
    }
});
  
  $('.slider-owl').owlCarousel({
    items: 1,
    nav: false,
    autoplay: true,
    margin: 0,
    dots: false,
    loop: false
  });
  
  $('.slider-counter__link').click(function() {
    $('.slider-counter__link').removeClass('slider-counter__link--active');
    $('.slider-counter__link').removeAttr('aria-current');
    
    $(this).addClass('slider-counter__link--active');
    $(this).attr('aria-current', 'true')
  });
  
    $(window).scroll(function(){
        if($(this).scrollTop() > 100){
            $('#scroll').fadeIn();
        }else{
            $('#scroll').fadeOut();
        }
    });
    $('#scroll').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });

    $('.toggle').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().toggleClass('show');

      var $this = $(this);

      if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
      } else {
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
      }
    });
    $('.template-index button.slider-button.slider-button--next').trigger('click');
    $(document).on("mouseenter", ".swatch_ele" , function() {
      var template = $('.templatefind').val(); 
      var title = $(this).attr('title');
      var dataid = $(this).attr('data-atr-id');
      var dataurl = $(this).attr('data-atr-url');
      var datasrc = $(this).attr('data-src');
      if (template == 'index') {
        datasrc = $(this).attr('dataindex-src');
      }
      $(this).parents('.card-wrapper').find('.main-img-card').attr('src', datasrc);
      $(this).parents('.card-wrapper').find('.main-img-card').attr('srcset', datasrc);
	  $(this).parents('.card-wrapper').find('.reference-meta').hide();
      $(this).parents('.card-wrapper').find('.style-ref-form-'+dataid).show();
      // if ($('body').hasClass('template-collection') ||
      //     $('body').hasClass('template-search')) {
      	$(this).parents('.card-wrapper').find('.swatch_ele').removeClass('current_swatch');
        $(this).addClass('current_swatch');
        $(this).parents('.card-wrapper').find('.linkabs').attr('href', dataurl);
        
      // }
      
      $(this).parents('.custom-field__product-swatches').find('span.dynamic_swatch').html(title);
    });

  $(document).on('click', '.size-box li.available-li', function() {
      this.cartNotification = document.querySelector('cart-notification');

      $(this).find('input').attr('checked', true);
      $(this).find('input').prop('checked', true);
	  $(this).parent('ul').css('visibility', 'hidden');
      $(this).parent('ul').siblings('.procard_loaader').show();
    
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(this).parent().parent().parent().parent().parent().parent("form").serialize(),
        success: function(response) {
		  refreshCart(false);
          $('.size-box li.available-li').parent('ul').css('visibility', 'visible');
          $('.procard_loaader').hide();
        },
        error: function() {
          $('.size-box li.available-li').parent('ul').css('visibility', 'visible');
          $('.procard_loaader').hide();
        }
      });
    });  
});

$(document).on('click', '.removeitem', function(e) {
  e.preventDefault();
  let variantId = $(this).attr("data-variant-id");
  console.log('variantIdvariantId', variantId)
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
  }).then((data) => {
    refreshCart(true);
  });
});

function calcCarousel() {
  var headerHeight = $("#shopify-section-header").height();
  var announceHeight = $(".announcementbar-wrapper").height();
  var t = headerHeight + announceHeight + 10;
  $(".template-index .slideshow.banner--medium:not(.banner--adapt)").css('min-height', 'calc(100vh - '+t+'px)');
}

function recommCarousel() {
  $('.product-recommendations ul.addcarousel').addClass('owl-carousel');
  $('.product-ref-wrapper ul').addClass('owl-carousel');
  $('.product-recommendations ul.addcarousel, .product-ref-wrapper ul').owlCarousel({
    items: 1,
    nav: true,
    autoplay: true,
    margin: 9,
    center: true,
    stagePadding: 40,
    dots: false,
    loop: true,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>","<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>"]
  });
  
  $('.helpages-wrap').css('opacity', '1');
  var a = $('.helpages-wrap .act-true').attr('data-index');
  $('ul.helpages.list-menu').addClass('owl-carousel');
    $('ul.helpages.list-menu').owlCarousel({
    items: 3,
    nav: false,
    autoplay: false,
    autoWidth:true,
    startPosition: a,
    stagePadding: 20,
    dots: false,
    loop: true
  });
  
}

$(window).on('resize', function(){
    var win = $(this); //this = window
    if (win.width() > 1280) {
      calcCarousel();
    }

    if (win.width() < 768) {
      recommCarousel();
    }
});
$(document).ready(function() {
  var win = $(this); //this = window
  if (win.width() > 1280) {
    calcCarousel();
  }
  if (win.width() < 768) {
    recommCarousel();
  }
  
  $('.header__icon.header__icon--cart').click(function(e) {
  	e.preventDefault();
    $('#cart-notification').toggleClass('animate active');
    $('.point-to-icon').toggleClass('animate active');
    $('.overlay_body').toggle();
    $('body').toggleClass('drawer--open');
  });
  
  $('button.cart-notification__close').click(function() {
  	$('.point-to-icon').removeClass('active');
    $('.point-to-icon').removeClass('animate');
    $('body').removeClass('drawer--open');
    $('.overlay_body').hide();
  });
  
  $('.inchesview').click(function() {
    $('.sizeincm').hide();
    $('.sizeininces').show();
  });
  $('.centimetersview').click(function() {
  	$('.sizeincm').show();
    $('.sizeininces').hide();
  });
  
  $('.facet-checkbox-lable').click(function() {
    var v = $(this).attr('value');
    $('select.facet-filters__sort')
    .val(v)
    .trigger('change').trigger('click');
    $('#FacetFiltersForm').submit();
  });
  
  $('.wrapper-attachedproducts label').click(function() {
  	var atr = $(this).attr('atr-variant');
    $(this).parents('.featured-product-reference').find('input[name="id"]').val(atr);    
  });
  
  $(".ajaxrefcall").each(function(i,v){
    var hn = $(this).attr('handle');
    var idd = $(this).attr('data-id');
    var that = $(this);
    if (hn) {
      jQuery.get('/products/'+hn+'?view=ref-swatches', function(pro) {
      that.html(pro);
      }).fail(function(jqXHR, textStatus, errorThrown) {
        console.log('getJSON request failed! ' + textStatus);
      }).done(function(){
        // $this.removeClass('recommendations');
      });
    }
  }); 

  $(".size-swatches-ref").each(function(i,v){
    var hn = $(this).attr('handle');
    var idd = $(this).attr('data-id');
    var that = $(this);
    if (hn) {
    jQuery.get('/products/'+hn+'?view=colour-ref-size-swatches', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.log('getJSON request failed! ' + textStatus);
    }).done(function(){
      // $this.removeClass('recommendations');
    });
    }
  }); 

  $(".title-swatches-ref").each(function(i,v){
    var hn = $(this).attr('handle');
    var idd = $(this).attr('data-id');
    var that = $(this);
    if (hn) {
    jQuery.get('/products/'+hn+'?view=ref-product-title', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.log('getJSON request failed! ' + textStatus);
    }).done(function(){
      // $this.removeClass('recommendations');
    });
    }
  }); 


  $(".ajaxrefcallprice").each(function(i,v){
    var hn = $(this).attr('handle');
    var idd = $(this).attr('data-id');
    var that = $(this);
    if (hn) {
    jQuery.get('/products/'+hn+'?view=ref-product-prices', function(pro) {
    that.html(pro);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.log('getJSON request failed! ' + textStatus);
    }).done(function(){
      // $this.removeClass('recommendations');
    });
    }
  }); 

  $(".ajaxrefcallwishlist").each(function(i,v){
    var hn = $(this).attr('handle');
    var idd = $(this).attr('data-id');
    var that = $(this);
    if (hn) {
    jQuery.get('/products/'+hn+'?view=ref-wishlist-icon', function(pro) {
    that.html(pro);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.log('getJSON request failed! ' + textStatus);
    }).done(function(){
      // $this.removeClass('recommendations');
    });
    }
  }); 
  
});
$(window).on('load', function () {
  var win = $(this); //this = window

  if (win.width() > 1280) {
    $('.template-product .product__media-list li:first-child button.deferred-media__poster').trigger('click');
  }
  if (win.width() < 767) {
    $('.product-recommendations .owl-nav button').html("<img src='https://cdn.shopify.com/s/files/1/1626/4849/files/next.svg?v=1676481264'>");
    $('.footer-block__heading').trigger('click');
  }
});
$(document).on('click', function (event) {
  if (!$(event.target).closest('#cart-notification').length &&
      !$(event.target).closest('#cart-icon-bubble').length) {
    $('#cart-notification').removeClass('animate active');
    $('.point-to-icon').removeClass('animate active');
    $('body').removeClass('drawer--open');
    $('.overlay_body').hide();
  }
});
$(document).on('click','footer .newsletter-form__field-wrapper', function () {
      var newWindowWidth = $(window).width();
      window._klOnsite = window._klOnsite || [];
    console.log('Klaviyo flyout')
      if (newWindowWidth < 768) {
          // window._klOnsite.push(['openForm', 'XsFE4w']);
        window._klOnsite.push(['openForm', 'YpiHd2']);
      } else {
        // window._klOnsite.push(['openForm', 'YrTJ2f']);
        window._klOnsite.push(['openForm', 'YdzGtk']);
      }
  });
  
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 90) {
        $("body").addClass("removeTitle");
    } else {
        $("body").removeClass("removeTitle");
    }
});

if ($(window).width() >= 768) {
  $(document).on('mouseenter','.swatch div', function () {
    if($(this).data("image").indexOf("no-image") == -1) {
      $(this).parents('.card--product').find('img').attr('src', $(this).data("image"));
      $(this).parents('.card--product').find('img').attr('srcset', $(this).data("image"));
    }
  });
  $('.card__inner.mobile').remove();
}
if ($(window).width() <= 768) { 
  // $('.linkabs').remove();
  $('.card__inner.desktop').remove();
  $('.card__inner.mobile').show();
  var owlscontext = $('.owl-carousels.mobile').owlCarousel({
      items: 1,
      nav: false,
      autoplay: false,
      responsiveClass:true,
      mouseDrag: true,
      touchDrag: true,
      smartSpeed: 800,
      loop: true,
      dots: true,    
    });    
  
  $('ul.change_mob_layout.hidden-tablet-and-upa li').on('click', function() {
      owlscontext.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
      $('.owl-carousels.mobile').css('opacity', '0');
      owlscontext = $('.owl-carousels.mobile').owlCarousel({
        items: 1,
        nav: false,
        autoplay: false,
        responsiveClass:true,
        mouseDrag: true,
        touchDrag: true,
        smartSpeed: 800,
        loop: true,
        dots: true,    
      });   
      setTimeout(function() {
        $('.owl-carousels.mobile').trigger('refresh.owl.carousel');  
        $('.owl-carousels.mobile').css('opacity', '1');
      }, 150);
  });
}

